"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var basedecoder_js_1 = __importDefault(require("./basedecoder.js"));

var MIN_BITS = 9;
var CLEAR_CODE = 256; // clear code

var EOI_CODE = 257; // end of information

var MAX_BYTELENGTH = 12;

function getByte(array, position, length) {
  var d = position % 8;
  var a = Math.floor(position / 8);
  var de = 8 - d;
  var ef = position + length - (a + 1) * 8;
  var fg = 8 * (a + 2) - (position + length);
  var dg = (a + 2) * 8 - position;
  fg = Math.max(0, fg);

  if (a >= array.length) {
    console.warn('ran off the end of the buffer before finding EOI_CODE (end on input code)');
    return EOI_CODE;
  }

  var chunk1 = array[a] & Math.pow(2, 8 - d) - 1;
  chunk1 <<= length - de;
  var chunks = chunk1;

  if (a + 1 < array.length) {
    var chunk2 = array[a + 1] >>> fg;
    chunk2 <<= Math.max(0, length - dg);
    chunks += chunk2;
  }

  if (ef > 8 && a + 2 < array.length) {
    var hi = (a + 3) * 8 - (position + length);
    var chunk3 = array[a + 2] >>> hi;
    chunks += chunk3;
  }

  return chunks;
}

function appendReversed(dest, source) {
  for (var i = source.length - 1; i >= 0; i--) {
    dest.push(source[i]);
  }

  return dest;
}

function decompress(input) {
  var dictionaryIndex = new Uint16Array(4093);
  var dictionaryChar = new Uint8Array(4093);

  for (var i = 0; i <= 257; i++) {
    dictionaryIndex[i] = 4096;
    dictionaryChar[i] = i;
  }

  var dictionaryLength = 258;
  var byteLength = MIN_BITS;
  var position = 0;

  function initDictionary() {
    dictionaryLength = 258;
    byteLength = MIN_BITS;
  }

  function getNext(array) {
    var byte = getByte(array, position, byteLength);
    position += byteLength;
    return byte;
  }

  function addToDictionary(i, c) {
    dictionaryChar[dictionaryLength] = c;
    dictionaryIndex[dictionaryLength] = i;
    dictionaryLength++;
    return dictionaryLength - 1;
  }

  function getDictionaryReversed(n) {
    var rev = [];

    for (var _i = n; _i !== 4096; _i = dictionaryIndex[_i]) {
      rev.push(dictionaryChar[_i]);
    }

    return rev;
  }

  var result = [];
  initDictionary();
  var array = new Uint8Array(input);
  var code = getNext(array);
  var oldCode;

  while (code !== EOI_CODE) {
    if (code === CLEAR_CODE) {
      initDictionary();
      code = getNext(array);

      while (code === CLEAR_CODE) {
        code = getNext(array);
      }

      if (code === EOI_CODE) {
        break;
      } else if (code > CLEAR_CODE) {
        throw new Error("corrupted code at scanline ".concat(code));
      } else {
        var val = getDictionaryReversed(code);
        appendReversed(result, val);
        oldCode = code;
      }
    } else if (code < dictionaryLength) {
      var _val = getDictionaryReversed(code);

      appendReversed(result, _val);
      addToDictionary(oldCode, _val[_val.length - 1]);
      oldCode = code;
    } else {
      var oldVal = getDictionaryReversed(oldCode);

      if (!oldVal) {
        throw new Error("Bogus entry. Not in dictionary, ".concat(oldCode, " / ").concat(dictionaryLength, ", position: ").concat(position));
      }

      appendReversed(result, oldVal);
      result.push(oldVal[oldVal.length - 1]);
      addToDictionary(oldCode, oldVal[oldVal.length - 1]);
      oldCode = code;
    }

    if (dictionaryLength + 1 >= Math.pow(2, byteLength)) {
      if (byteLength === MAX_BYTELENGTH) {
        oldCode = undefined;
      } else {
        byteLength++;
      }
    }

    code = getNext(array);
  }

  return new Uint8Array(result);
}

var LZWDecoder = /*#__PURE__*/function (_basedecoder_js_1$def) {
  (0, _inherits2.default)(LZWDecoder, _basedecoder_js_1$def);

  var _super = _createSuper(LZWDecoder);

  function LZWDecoder() {
    (0, _classCallCheck2.default)(this, LZWDecoder);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LZWDecoder, [{
    key: "decodeBlock",
    value: function decodeBlock(buffer) {
      return decompress(buffer, false).buffer;
    }
  }]);
  return LZWDecoder;
}(basedecoder_js_1.default);

exports.default = LZWDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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